import script from "./Outpaint.vue?vue&type=script&setup=true&lang=ts"
export * from "./Outpaint.vue?vue&type=script&setup=true&lang=ts"

import "./Outpaint.scss?vue&type=style&index=0&id=4477874d&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4477874d"]])

export default __exports__